import { render, staticRenderFns } from "./DeltaPart.vue?vue&type=template&id=7462c5d4&scoped=true"
import script from "./DeltaPart.vue?vue&type=script&lang=js"
export * from "./DeltaPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7462c5d4",
  null
  
)

export default component.exports